import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../utils/axios";
import { SUBMIT_ASKNOW_TICKET, MIDDLE_WARE_BASE_URL_v1 } from "../../../utils/CONSTANTS";

const initialState = {
  reportIssueState: '',
  reportIssueData: '',
};

export const reportIssues = createAsyncThunk(
  "get/submitAsknowTicket",
  async (data: any) => {
    const response = axios.postRequest(
      MIDDLE_WARE_BASE_URL_v1() + SUBMIT_ASKNOW_TICKET(),
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  }
);

const reportIssuesSlice = createSlice({
  name: "reportIssue",
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(reportIssues.pending, (state) => {
        state.reportIssueState = "pending";
      })
      .addCase(reportIssues.fulfilled, (state, action) => {
        let tempRes = action.payload;
        if (typeof tempRes === "string") {
          tempRes = JSON.parse(tempRes);
        }
        state.reportIssueState = "fulfilled";
        state.reportIssueData = JSON.stringify(tempRes);
      })
      .addCase(reportIssues.rejected, (state) => {
        state.reportIssueState = "failed";
      })
});

export const postreportIssue = (state: any) => state.reportIssues;
export default reportIssuesSlice.reducer;
